import {
  SET_CLASSIFICATION_FORMS, SET_AFFECTED_VEHICLES_FORMS,
  SET_RECIPIENTS_FORMS, SET_VOLUMES_FORMS, SET_ATTACHMENTS_FORMS, SET_SOFTWARE_FORMS, SET_SUMMARY_FORMS, SET_SUBCRFEEDBACK_FORMS,
  SET_CAMPAIGN_STATUSES_FORMS, SET_SUBCAMPAIGN_STATUSES_FORMS, SET_LANGUAGES_FORM, SET_PLANTS_FORM, SET_DESCRIPTION_FORMS,
  SET_FORMS,
} from '../types';

const initialState = {
  description: {},
  classification: {},
  software: {},
  vehicles: {},
  recipients: {},
  attachement: {},
  summary: {},
  subcrfeedback: {},
  campaignStatuses: [],
  subCampaignStatuses: [],
  languages: {},
  plants: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_FORMS:
      return {
        ...state,
        ...action.payload,
      };
    case SET_DESCRIPTION_FORMS:
      return {
        ...state,
        description: action.payload,
      };
    case SET_CLASSIFICATION_FORMS:
      return {
        ...state,
        classification: action.payload,
      };
    case SET_SOFTWARE_FORMS:
      return {
        ...state,
        software: action.payload,
      };
    case SET_AFFECTED_VEHICLES_FORMS:
      return {
        ...state,
        vehicles: action.payload,
      };
    case SET_VOLUMES_FORMS:
      return {
        ...state,
        volumes: action.payload,
      };
    case SET_RECIPIENTS_FORMS:
      return {
        ...state,
        recipients: action.payload,
      };
    case SET_ATTACHMENTS_FORMS:
      return {
        ...state,
        attachement: action.payload,
      };
    case SET_SUMMARY_FORMS:
      return {
        ...state,
        summary: action.payload,
      };
    case SET_SUBCRFEEDBACK_FORMS:
      return {
        ...state,
        subcrfeedback: action.payload,
      };
    case SET_CAMPAIGN_STATUSES_FORMS:
      return {
        ...state,
        campaignStatuses: action.payload,
      };
    case SET_SUBCAMPAIGN_STATUSES_FORMS:
      return {
        ...state,
        subCampaignStatuses: action.payload,
      };
    case SET_LANGUAGES_FORM:
      return {
        ...state,
        languages: action.payload,
      };
    case SET_PLANTS_FORM:
      return {
        ...state,
        plants: action.payload,
      };

    default:
      return state;
  }
};

export const getForms = (state) => state.formsReducer;
export const getDescriptionForms = (state) => state.formsReducer.description;
export const getClassificationForms = (state) => state.formsReducer.classification;
export const getSoftwareForms = (state) => state.formsReducer.software;
export const getAffectedVehiclesForms = (state) => state.formsReducer.vehicles;
export const getRecipientsForms = (state) => state.formsReducer.recipients;
export const getVolumesForms = (state) => state.formsReducer.volumes;
export const getAttachementForms = (state) => state.formsReducer.attachement;
export const getSummaryForms = (state) => state.formsReducer.summary;
export const getSubCRFeedbackForms = (state) => state.formsReducer.subcrfeedback;
export const getCampaignStatusesForms = (state) => state.formsReducer.campaignStatuses;
export const getSubCampaignStatusesForms = (state) => state.formsReducer.subCampaignStatuses;
export const getLanguagesForm = (state) => state.formsReducer.languages;
export const getPlantsForm = (state) => state.formsReducer.plants;
